import React, { useContext } from 'react';
import { List, ListItem, SxProps, Theme, Typography } from '@mui/material';
import { UIContext } from '../context/UIContext';

interface BulletListItem {
    id: string;
    text: string;
}

interface BulletListProps {
    items: BulletListItem[];
}

const BulletList = ({ items }: BulletListProps) => {
    const { isMobile, isTablet } = useContext(UIContext);
    const listStyles: SxProps = (isMobile || isTablet) ? {fontSize: '14px', lineHeight: '143%', fontWeight: 700} : {fontSize: '10px', lineHeight: '14px'};
    
    return (
    <List
        sx={{
            listStyleType: 'disc',
            pl: 2,
            py: 0,
            '& .MuiListItem-root': {
                display: 'list-item',
                py: 0,
            },
            marginLeft: '12px',
        }}
    >
        {items.map(({ id, text }) => (
            <ListItem disableGutters key={id}>
               <Typography variant="body1" sx={listStyles}>{text}</Typography>
            </ListItem>
        ))}
    </List>
)};

export default BulletList;
